import React from "react";
import { useAppContext } from "./store";
import { MenuAuthorityChoice } from "./common";

export default function AuthorityCheckRoute(props) {
  const { authority, children } = props;
  const {
    store: { isSuperUser, remsEnabled, externalApiEnabled },
  } = useAppContext();
  console.log(authority);
  if (isSuperUser) return children;

  if (authority === MenuAuthorityChoice.ADMIN) return null;

  if (authority === MenuAuthorityChoice.REMS && remsEnabled === false)
    return null;
  if (authority === MenuAuthorityChoice.API && externalApiEnabled === false)
    return null;

  return children;
}
